<template>

<div>

	<com-page v-if="$route.meta.public" :loading="is.loading">

		<router-view :key="$keyPath" />

	</com-page>
		
	<com-screen v-if="!$route.meta.public" id="app" :loading="is.loading">

		<router-view :key="$keyPath" />

		<template v-slot:menu>

			<com-menu>
			
				<com-foot v-if="!window.is.desktop" />

			</com-menu>

		</template>

		<com-foot v-if="window.is.desktop" />

	</com-screen>
	
</div>

</template>

<script>

import comScreen from './screen/Wrapper'
import comMenu from './screen/public/Menu'
import comFoot from './screen/Foot'

export default {

	name: 'App',

	components: {

		'com-screen': comScreen,
		'com-menu': comMenu,
		'com-foot': comFoot,
		'com-page': () => import('./screen/public/Page')

	},

	data: function() {

		return {
			is: {
				initiated: false,
				loading: true
			}
		}

	},

	watch: {

		context: function() {

			this.load()

		}

	},

	computed: {

		context: function() {

			if (this.$route.meta.public) {

				return 'public'

			} else {

				return this.$route.params.organisation + '-' + this.$route.params.convention

			}

		}

	},

	methods: {

		load: function() {

			this.is.loading = true
			this.is.initiated = false

			if (this.context !== 'public') {
				
				this.$api.get('check', this.$route.params).then(function(json) {

					this.$store.commit('session/set', {
						conventions: [json.convention],
						organisations: [json.organisation]
					})

					this.$store.commit('context/organisation', json.organisation)
					this.$store.commit('context/convention', json.convention)

					this.is.initiated = true
					this.is.loading = false

				}.bind(this), function() {

					this.$router.push({
						name: 'Home'
					})

				}.bind(this))

			} else {

				this.is.initiated = true
				this.is.loading = false

			}

		}

	}

}

</script>

<style>

</style>
